import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SalesTracker from './pages/SalesTracker';
import UserManagement from './pages/UserManagement';
import RoleManagement from './pages/RoleManagement';
import PermissionManagement from './pages/PermissionManagement';
import Profile from './pages/Profile';
import PurchaseTracker from './pages/PurchaseTracker';
import OrderTracker from './pages/OrderTracker';
import Reports from './pages/Reports';
import CurrencyPage from "./pages/CurrencyPage";
import VendorTracker from './pages/VendorTracker';


const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
});

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, loading, user } = useAuth();
  
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requiredRole && user?.role_name !== requiredRole && !user?.is_superuser) {
    return <Navigate to="/dashboard" />;
  }
  
  return children;
};

const AppRoutes = () => {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/dashboard" />} />
      
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Layout>
            <Dashboard />
          </Layout>
        </ProtectedRoute>
      } />
      <Route path="/vendors" element={
  <ProtectedRoute>
    <Layout>
      <VendorTracker />
    </Layout>
  </ProtectedRoute>
} />

      
      <Route path="/sales" element={
        <ProtectedRoute>
          <Layout>
            <SalesTracker />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/users" element={
        <ProtectedRoute>
          <Layout>
            <UserManagement />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/roles" element={
        <ProtectedRoute>
          <Layout>
            <RoleManagement />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/permissions" element={
        <ProtectedRoute>
          <Layout>
            <PermissionManagement />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/profile" element={
        <ProtectedRoute>
          <Layout>
            <Profile />
          </Layout>
        </ProtectedRoute>
      } />
  <Route path="/orders" element={
  <ProtectedRoute>
    <Layout>
      <OrderTracker />
    </Layout>
  </ProtectedRoute>
} />
<Route path="/purchase" element={
  <ProtectedRoute>
    <Layout>
      <PurchaseTracker />
    </Layout>
  </ProtectedRoute>
} />
<Route path="/reports" element={
  <ProtectedRoute>
    <Layout>
      <Reports />
    </Layout>
  </ProtectedRoute>
} />
   <Route path="/currency" element={
        <ProtectedRoute>
          <Layout>
            <CurrencyPage />
          </Layout>
        </ProtectedRoute>
      } />
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;